import React, {useRef, useState, useEffect} from 'react';
import clsx from 'clsx';

import styles from './styles.module.scss';
import {AntiWebhook} from '../../../components/Features/AntiWebhook';
import {AntiSpam} from '../../../components/Features/AntiSpam';
import {Verification} from '../../../components/Features/Verification';
import {AntiNuke} from '../../../components/Features/AntiNuke';
import {FakeDetection} from '../../../components/Features/FakeDetection';
import {AntiRaid} from '../../../components/Features/AntiRaid';
import {Button} from '../../../components/Button';
import {ArrowLong, Grid} from '../../../assets';
import {featuresLinks} from '../../../constants/links';
import {ScrollMenu} from '../../../components/ScrollMenu';

const FEATURES = {
  AntiWebhook: 'Anti-Webhook',
  AntiSpam: 'Anti-Spam',
  Verification: 'Verification',
  AntiNuke: 'Anti-Nuke',
  FakeDetection: 'Fake Detection',
  AntiRaid: 'Anti-Raid',
};

export const Main = () => {
  const block1Ref = useRef(null);
  const block2Ref = useRef(null);
  const block3Ref = useRef(null);
  const block4Ref = useRef(null);
  const block5Ref = useRef(null);
  const block6Ref = useRef(null);
  const scrollMenuRef = useRef(null);
  const [active, setActive] = useState(FEATURES.AntiWebhook);
  const [isScrollMenu, setScrollMenu] = useState(false);

  const scrollToBlock = (ref, feature) => {
    setActive(feature);
    ref.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  const data = [
    {
      text: 'Anti-Webhook',
      onClick: () => scrollToBlock(block1Ref, FEATURES.AntiWebhook),
    },
    {
      text: 'Anti-Spam',
      onClick: () => scrollToBlock(block2Ref, FEATURES.AntiSpam),
    },
    {
      text: 'Verification',
      onClick: () => scrollToBlock(block3Ref, FEATURES.Verification),
    },
    {
      text: 'Anti-Nuke',
      onClick: () => scrollToBlock(block4Ref, FEATURES.AntiNuke),
    },
    {
      text: 'Fake Detection',
      onClick: () => scrollToBlock(block5Ref, FEATURES.FakeDetection),
    },
    {
      text: 'Anti-Raid',
      onClick: () => scrollToBlock(block6Ref, FEATURES.AntiRaid),
    },
  ];

  const handleScroll = () => {
    const blockRect = scrollMenuRef.current.getBoundingClientRect();
    const isBlockInViewport = blockRect.top <= 0;

    setScrollMenu(isBlockInViewport);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleActive = () => {
    const blockRect1 = block1Ref.current.getBoundingClientRect();
    const blockRect2 = block2Ref.current.getBoundingClientRect();
    const blockRect3 = block3Ref.current.getBoundingClientRect();
    const blockRect4 = block4Ref.current.getBoundingClientRect();
    const blockRect5 = block5Ref.current.getBoundingClientRect();
    const blockRect6 = block6Ref.current.getBoundingClientRect();

    const isBlockInViewport1 = blockRect1.top <= 0;
    const isBlockInViewport2 = blockRect2.top <= 0;
    const isBlockInViewport3 = blockRect3.top <= 0;
    const isBlockInViewport4 = blockRect4.top <= 0;
    const isBlockInViewport5 = blockRect5.top <= 0;
    const isBlockInViewport6 = blockRect6.top <= 0;

    if (isBlockInViewport1) {
      setActive(FEATURES.AntiWebhook);
    }

    if (isBlockInViewport2) {
      setActive(FEATURES.AntiSpam);
    }

    if (isBlockInViewport3) {
      setActive(FEATURES.Verification);
    }

    if (isBlockInViewport4) {
      setActive(FEATURES.AntiNuke);
    }

    if (isBlockInViewport5) {
      setActive(FEATURES.FakeDetection);
    }

    if (isBlockInViewport6) {
      setActive(FEATURES.AntiRaid);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleActive);

    return () => {
      window.removeEventListener('scroll', handleActive);
    };
  }, []);

  return (
    <div className={styles.main}>
      <div
        className={clsx(styles.scrollMenu, {
          [styles.active]: isScrollMenu,
        })}>
        <ScrollMenu data={data} active={active} />
      </div>

      <div className={styles.container}>
        <div className={styles.menu}>
          <div className={styles.menuContent}>
            {data.map(({text, onClick}) => (
              <div
                key={text}
                className={clsx(styles.menuItem, {
                  [styles.active]: active === text,
                })}
                onClick={onClick}>
                {text}
              </div>
            ))}
          </div>
        </div>
        <div ref={scrollMenuRef}>
          <div ref={block1Ref}>
            <AntiWebhook />
          </div>
          <div ref={block2Ref}>
            <AntiSpam />
          </div>
          <div ref={block3Ref}>
            <Verification />
          </div>
          <div ref={block4Ref}>
            <AntiNuke />
          </div>
          <div ref={block5Ref}>
            <FakeDetection />
          </div>
          <div ref={block6Ref}>
            <AntiRaid />
          </div>
        </div>

        <h3 className={styles.title}>Security made simple</h3>
        <p className={styles.subTitle}>
          Protect and manage any server of any size with comprehensive security
        </p>
        <div className={styles.button}>
          <Button
            text="Explore documentation"
            icon={<ArrowLong />}
            href={featuresLinks.documentation}
            target="_blank"
          />
        </div>
      </div>
      <div className={styles.grid}>
        <Grid />
      </div>
    </div>
  );
};
